import instanceAxios from "./intanceAxios";


export const TaskService = {
    createTask: async (task) =>  await instanceAxios.post('/otask/task/', task),
    getTasks: async (filters) => await instanceAxios.get('/otask/task/', { params: filters }),
    getTaskByHash: async (hash_code, ot_id, task_scheduled_id) => await instanceAxios.get(`/otask/task-detail/${hash_code}/`, { params: { ot_id, task_scheduled_id } }), 
    deleteTask: async (id) => await instanceAxios.delete(`/otask/task/?id=${id}`),
    updateTask: async (data) => await instanceAxios.put('/otask/task/', data),
    updateSubtaskResponse: async (data) => await instanceAxios.post('/otask/subtask-response/', data),
    updateTaskResource: async (data) => await instanceAxios.put('/otask/task-resource/', data),
    saveSsomaCode: async (data) => await instanceAxios.post('/otask/ssoma-code/', data),
    startTask: async (data) => await instanceAxios.post('/otask/task-start/', data),
    finishTask: async (data) => await instanceAxios.post('/otask/task-finish/', data),
    saveTaskAttach: async (data) => await instanceAxios.post('/otask/task-attach/', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }), 
    deleteTaskAttach: async (data) => await instanceAxios.delete('/otask/task-attach/', { data }),
    addResourceToTask: async (data) => await instanceAxios.post('/otask/task-resource-add/', data),

    getTasksCalendar: async (filters) => await instanceAxios.get('/otask/task-calendar/', { params: filters }),
    getTasksMonthExcel: async (filters) => await instanceAxios.get('/otask/task-month-excel/', { params: filters, responseType: 'blob' })
}